import { isPossiblePhoneNumber } from 'react-phone-number-input'

import type { IFieldRule } from 'components/controls/Field/Field.types'
import { t } from 'services/Translation'

import { validateEmail } from './emailValidation'

export const validateUrl = (value?: string | null) => {
  if (!value) {
    return false
  }

  // Added support for query params and hashes in the last group: ([/?#][\w\-./а-я=&%?#+]*)?
  const regStr =
    /^(https?:\/\/)?((([a-zа-я0-9-]+\.)+[a-zа-я0-9-]{2,20})|(([0-9]{1,3}\.){3}[0-9]{1,3}))(:[0-9]{1,5})?([/?#][\w\-./а-я=&%?#;:+]*)?$/i

  return regStr.test(String(value).toLowerCase())
}

export const validateLinkUrl = (value?: string | null) => {
  if (!value) {
    return false
  }

  return validateUrl(value) || validateEmail.test(value)
}

export const prepareLinkUrl = (link: string) => {
  const isURLCorrect = /^https?/.test(link)
  const isTemplatesLink = /\.\/templates/.test(link)
  const mailto = 'mailto:'
  const isEmail = validateEmail.test(link)
  const isFullEmail = link.startsWith(mailto) && validateEmail.test(link.replace(mailto, ''))
  const linkToEmail = isFullEmail ? link : isEmail ? `${mailto}${link}` : null
  const linkToUrl = isURLCorrect || isTemplatesLink ? link : `//${link}`
  const correctLink = linkToEmail || linkToUrl
  return correctLink
}
export const prepareUrl = (link: string) => {
  const isURLCorrect = /^https?/.test(link) || /^\//.test(link) || /^\.\//.test(link)
  const linkToUrl = isURLCorrect ? link : `//${link}`
  return linkToUrl
}

export const linkUrlValidation = <V>(rule: IFieldRule<V>, value?: unknown) => {
  const isValid = typeof value === 'string' && validateLinkUrl(value)
  if (!isValid && value) {
    return rule.message || t('input.error.invalidUrl')
  }
  return false
}

export const urlValidation = <V>(rule: IFieldRule<V>, value?: unknown) => {
  const isValid = typeof value === 'string' && validateUrl(value)
  if (!isValid && value) {
    return rule.message || t('input.error.invalidUrl')
  }
  return false
}

export const iframeLinkValidation = <V>(rule: IFieldRule<V>, value?: unknown) => {
  const regStr = /^https?:\/\/.+/
  const isValid = typeof value === 'string' && regStr.test(value.toLowerCase())
  if (!isValid && value) {
    return rule.message || t('input.error.invalidUrl')
  }
  return false
}

export const phoneValidation = <V>(rule: IFieldRule<V>, value?: unknown) => {
  if (!value || (typeof value === 'string' && isPossiblePhoneNumber(value))) {
    return false
  }

  return rule.message || 'Incorrect phone number'
}
